import { Link } from 'react-router-dom';
import { IfWrites } from '../write-access';

/** The page head's add button on Home and People, for writers only. */
export function NewPersonLink() {
  return (
    <IfWrites>
      <div className="actions-right">
        <Link className="btn hero" to="/people/new">
          <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M6 2v8M2 6h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
          New person
        </Link>
      </div>
    </IfWrites>
  );
}
